import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Switch
} from '@mui/material';

const UserForm = ({ open, onClose, onSubmit, initialData = null, roles = [], isEditing = false }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    role_id: '',
    is_active: true
  });

  useEffect(() => {
    if (initialData && open) {
      setFormData({
        username: initialData.username || '',
        password: '', // Não enviamos a senha atual do servidor
        role_id: initialData.role_id || '',
        is_active: initialData.is_active !== undefined ? initialData.is_active : true
      });
    } else if (!open) {
      // Reset form when dialog closes
      setFormData({
        username: '',
        password: '',
        role_id: '',
        is_active: true
      });
    }
  }, [initialData, open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSwitchChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Se estiver editando e a senha estiver vazia, remova o campo da submissão
    if (isEditing && !formData.password.trim()) {
      const { password, ...dataWithoutPassword } = formData;
      onSubmit(dataWithoutPassword);
    } else {
      onSubmit(formData);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{isEditing ? 'Editar Usuário' : 'Novo Usuário'}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              label="Nome de Usuário"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              fullWidth
              autoFocus
              disabled={isEditing} // Normalmente não permitimos alterar o username após criação
            />

            <TextField
              label={isEditing ? "Nova Senha (deixe em branco para manter)" : "Senha"}
              name="password"
              type="password"
              value={formData.password}
              onChange={handleChange}
              required={!isEditing}
              fullWidth
            />

            <FormControl fullWidth required>
              <InputLabel id="role-select-label">Perfil</InputLabel>
              <Select
                labelId="role-select-label"
                name="role_id"
                value={formData.role_id}
                onChange={handleChange}
                label="Perfil"
              >
                {Array.isArray(roles) ? roles.map(role => (
                  <MenuItem key={role.role_id} value={role.role_id}>
                    {role.role_name}
                  </MenuItem>
                )) : null}
              </Select>
            </FormControl>

            <FormControlLabel
              control={
                <Switch
                  checked={formData.is_active}
                  onChange={handleSwitchChange}
                  name="is_active"
                  color="primary"
                />
              }
              label="Usuário Ativo"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
          <Button type="submit" variant="contained" color="primary">
            {isEditing ? 'Salvar Alterações' : 'Criar Usuário'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default UserForm; 